// extracted by mini-css-extract-plugin
export default {"errorFormat":"ModalApplicationList_errorFormat__7h+QP"};